import React from 'react';
import { Chart } from 'react-google-charts';
import Spinner from '../../common/Spinner/Spinner';

const DigitalEnablementPieChart = ({ data, allDepDeliveredCount, entrepreneursCount, digitalEanblementProgramCharDatatLoading, isGetAllDeliveredCountLoading, repeatGroupKnowledgeSessionUser }) => {
    // Count occurrences of each category
    const categoryCounts = {};
    data.forEach(item => {
        // const category = item.sCategory ? item.sCategory : "Other" ;
        const category = item.sResourceDisplayName ? item.sResourceDisplayName : 'Other';
        const count = item.sMobile_count || 1; // If sMobile_count is not present, default to 1
        categoryCounts[category] = (categoryCounts[category] || 0) + count;
    });

    // Prepare data for the pie chart
    const chartData = Object.entries(categoryCounts).map(([category, count]) => [category, count]);

    // Add header for the chart
    const chartHeader = [['Category', 'Count'], ...chartData];

    return (
        <div>
            <div className={`${(digitalEanblementProgramCharDatatLoading || isGetAllDeliveredCountLoading) ? "set-opacity" : ""}`} style={{ height: "50vh" }}>
                {(digitalEanblementProgramCharDatatLoading || isGetAllDeliveredCountLoading)? <Spinner className="center" /> : ""}
                <Chart
                    width={'100%'}
                    height="100%"
                    chartType="PieChart"
                    loader={<div>Loading...</div>}
                    data={chartHeader}
                    options={{
                        backgroundColor: "#ddd",
                        title: `${allDepDeliveredCount !== undefined ? allDepDeliveredCount : 0} Digital Enablement Solution delivered to ${entrepreneursCount !== undefined ? entrepreneursCount : 0} entrepreneurs`,

                        // title: 'Knowledge Resources by Category',
                        // title: `${allGroupKnowledgeSessionDeliveredCount} knowledge sessions delivered to ${entrepreneursCount} entrepreneurs`,
                        // title: `${entrepreneursCount} unique attendees participated in ${allGroupKnowledgeSessionDeliveredCount} sessions together,
                        // with ${repeatGroupKnowledgeSessionUser} returning for multiple sessions.`,
                        titleTextStyle: {
                            fontSize: 10,
                            bold: true,
                            color: "#333",
                        },
                        chartArea: {
                            left: "15%",  // Centers the chart horizontally
                            width: "78%", // Adjust width to allow space for the title
                            height: "50%", // Reduce height so title remains inside
                            top: 80, // Moves the chart down, keeping title inside
                        },
                
                    }}
                />
            </div>
        </div>
    );
};

export default DigitalEnablementPieChart;